<div class="row mt-2">

  <!-- User Detail -->
  <app-user-detail *ngIf="(trainsInfo.isAdmin && trainsInfo.canUseTRM) || trainsInfo.isEmployee"
    [userUuid]="trainsInfo.userToBook" (navigateEvent)="goBack()" style="width: 100%">
  </app-user-detail>

  <div class="container">

    <!-- HEADER -->
    <div class="header">
      <h5>{{ onView === 'outward'
        ? ('train.search-result.outward-train' | translate)
        : ('train.search-result.return-train' | translate) }}</h5>

      <div class="search-data">
        <span>
          {{ onView === 'outward'
          ? trainsInfo?.searchConfig?.origin?.name + ' - ' + trainsInfo?.searchConfig?.destination?.name
          : trainsInfo?.searchConfig?.destination?.name + ' - ' + trainsInfo?.searchConfig?.origin?.name }}
        </span>
        <span>
          {{ onView === 'outward'
          ? (utilsService.formatDate(trainsInfo?.searchConfig?.departDate) | date)
          : (utilsService.formatDate(trainsInfo?.searchConfig?.returnDate) | date) }}
        </span>
      </div>

      <button class="search-button" (click)="changeSearchParams()">
        {{ "flight.result-flight.modify-search" | translate }}
      </button>
    </div>

    <!-- TRAIN RESULTS -->
    <div class="content" *ngIf="(onView === 'outward'
                 ? trainsInfo?.trainsList?.outward?.length > 0
                 : trainsInfo?.trainsList?.return?.length > 0)">

      <div class="results">

        <!-- Paging Previous -->
        <button class="paging-button"
          (click)="onView === 'outward' ? onSearch('Previous') : onSearchReturn('Previous')">
          <img src="assets/img/svg/arrow-right.svg" alt="" style="transform: rotate(-90deg);" />
          <span>{{"common.earlier" | translate}}</span>
        </button>

        <!-- Train List -->
        <mat-accordion>
          <div
            *ngFor="let train of (onView === 'outward' ? trainsInfo.trainsList.outward : trainsInfo.trainsList.return); let i = index">
            <div class="search-day"
              *ngIf="i === 0 || isDifferentDay(train, (onView === 'outward' ? trainsInfo.trainsList.outward[i - 1] : trainsInfo.trainsList.return[i - 1]))">
              {{ formatDate(train.departDate) }}
            </div>
            <mat-expansion-panel class="train-container" [expanded]="false" [multi]="false"
              (opened)="isSelectedTrain(train, onView)" [ngClass]="{'selected-train': isSelectedTrain(train, onView)}">
              <mat-expansion-panel-header (click)="trainService.selectTrain(train, onView, trainsInfo)">
                <mat-panel-title>
                  <div class="train-header">
                    <div class="hours">
                      <p>{{ train.departDate | date:'HH:mm' }}</p>
                      <img src="assets/img/svg/arrow-right.svg" alt="" />
                      <p>{{ train.arriveDate | date:'HH:mm' }}</p>
                    </div>

                    <div class="time-container">
                      <div>
                        {{getCarrierNames(train)}}
                      </div>
                      <div class="hours-info">
                        <span class="duration">{{ trainService.getDuration(train) }}</span>
                        <span class="changes" (click)="train.sections.length > 1 ? openSectionsModal(train) : ''">
                          {{ train.sections.length > 0 ? train.sections.length - 1 : train.sections.length }}
                          {{'train.search-result.stops' | translate}}
                        </span>
                      </div>
                    </div>
                    <div class="price">
                      <span>{{'train.prices.from' | translate}} {{ (trainsInfo?.company?.showCommissions ? train.minPrice
                        : (train.minPrice + train.finalCommision)) | number:'1.2-2' }} €</span>
                    </div>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <div *ngFor="let section of train.sections">
                  <hr />
                  <div class="section-header">
                    <span>{{section.alternatives[0].origin}} - {{section.alternatives[0].destination}}</span>
                    <span class="duration">{{ trainService.getDuration(section.alternatives[0]) }}</span>
                    <img class="carrier-logo" [src]="trainService.getCarrierLogo(section.alternatives[0]?.carrier)"
                      alt="Carrier logo" />
                  </div>
                  <div>
                    <div class="train">
                      <div style="width: 100%;">
                        <div class="carriers">
                          <div style="width: 100%;" *ngFor="let alternative of section.alternatives">
                            <div class="sections-container">
                              <p>{{ alternative.fareName }}</p>
                              <p>{{ getFlexibilityString(alternative?.flexibility) }}</p>
                              <div class="price"
                                (click)="trainService.selectTrain(train, onView, trainsInfo, [alternative.alternativeId])"
                                [ngClass]="{'selected-alternative': isSelectedAlternative(alternative, onView)}">
                                <span>{{ getTrainPrice(train, alternative) }} €</span>
                              </div>
                            </div>
                            <div
                              *ngIf="!isPriceWithinRangeMethod(train) || trainsInfo.userFilters.onlyTrainAuthorization"
                              style="display: flex; justify-content: center;">
                              <span class="admin-permission-msg">
                                {{ "common.out-politics" | translate }}
                              </span>
                            </div>

                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>`
              </div>
            </mat-expansion-panel>
          </div>
        </mat-accordion>

        <!-- Paging Next -->
        <button class="paging-button" (click)="onView === 'outward' ? onSearch('Next') : onSearchReturn('Next')">
          <img src="assets/img/svg/arrow-right.svg" style="transform: rotate(90deg);" alt="" />
          <span>{{"common.later" | translate}}</span>
        </button>

      </div> <!-- end results -->

      <!-- SUMMARY -->
      <div class="summary">
        <div class="fixed-footer">
          <app-trains-summary style="width: 50%;" [activePage]="'result'" [onView]="onView"
            (onViewDepartEvent)="onViewDepart()" (onSearchReturnEvent)="onSearchReturn()"
            (onSelectTrainsEvent)="onSelectTrains()">
          </app-trains-summary>
        </div>
      </div>

    </div> <!-- end content -->
    <div class="empty-results" *ngIf="
        (onView === 'outward' ?
          !trainsInfo?.trainsList?.outward || (trainsInfo?.trainsList?.outward?.length < 1)
          : !trainsInfo?.trainsList?.return || (trainsInfo?.trainsList?.return?.length < 1)) &&
        !utilsService.loadingTrains
      ">
      <img src="assets/img/svg/empty-results.svg" alt="Empty results" />
      <p class="no-results">
        Ups...
        {{ "agency.search.search-homepage.no-results" | translate }}
      </p>
      <p>{{ "common.change-search" | translate }}</p>
    </div>

  </div> <!-- end container -->
</div> <!-- end row -->